const parseXml = (xml, errorMessage = 'Invalid patient-history XML response') => {
  const document = new DOMParser().parseFromString(xml, 'application/xml');

  if (document.getElementsByTagName('parsererror').length > 0) {
    throw new Error(errorMessage);
  }

  return document;
};

const findElementByLocalName = (document, name) => Array.from(document.getElementsByTagName('*'))
  .find((element) => element.localName === name);

const attributesToObject = (element) => Array.from(element.attributes)
  .reduce((attributes, attribute) => ({ ...attributes, [attribute.name]: attribute.value }), {});

export const parsePatientHistorySoap = (soapXml) => {
  const soapDocument = parseXml(soapXml);
  const resultElement = findElementByLocalName(soapDocument, 'ConsultarPacienteResult');

  if (!resultElement) throw new Error('Patient-history result was not found');

  const resultDocument = parseXml(resultElement.textContent.trim());
  const status = resultDocument.getElementsByTagName('Status')[0]?.textContent.trim();
  const patientElement = resultDocument.getElementsByTagName('Patient')[0];

  if (status !== 'OK' || !patientElement) {
    throw new Error('Patient-history request was not successful');
  }

  return {
    patient: attributesToObject(patientElement),
    studies: Array.from(patientElement.getElementsByTagName('Study'))
      .map((studyElement) => attributesToObject(studyElement)),
  };
};

const escapeXml = (value = '') => String(value)
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;')
  .replace(/'/g, '&apos;');

export const buildPatientHistorySoapRequest = (template, props = {}) => {
  if (typeof template !== 'string') {
    throw new Error('Patient-history SOAP template must be a string');
  }

  const populatedTemplate = template.replace(/{{([A-Za-z][A-Za-z0-9_]*)}}/g,
    (placeholder, fieldName) => escapeXml(
      Object.prototype.hasOwnProperty.call(props, fieldName) ? props[fieldName] : ''
    ));

  const templateDocument = parseXml(populatedTemplate, 'Invalid patient-history SOAP template');

  Object.entries(props).forEach(([fieldName, value]) => {
    Array.from(templateDocument.getElementsByTagName('*'))
      .filter((element) => element.localName === fieldName)
      .forEach((element) => {
        while (element.firstChild) {
          element.removeChild(element.firstChild);
        }
        element.appendChild(templateDocument.createTextNode(
          value === undefined || value === null ? '' : String(value)
        ));
      });
  });

  return new XMLSerializer().serializeToString(templateDocument);
};

export default parsePatientHistorySoap;
